export const MethodBadgePost = () => (
  <span className="inline-block w-16 rounded bg-[var(--color-success-bg)] px-2 py-1 text-center text-xs font-bold text-[var(--color-success-text)]">
    POST
  </span>
);
